import { track } from "@amplitude/analytics-react-native";
import toast from "src/swsh-native/toast";
import { useCallback } from "react";
import { amp } from "src/api/amplitude";
import { alert } from "src/swsh-native";
import useDeletePhotos from "./useDeletePhotos";

const usePromptDeletePhoto = () => {
	const handleDeletePhotos = useDeletePhotos();
	const handleDeletePhoto = useCallback(
		async (photoId: string, { onDelete }: { onDelete?: () => void } = {}) => {
			track(amp.photo.delete.initiate, {
				photoId,
			});
			alert({
				title: "Delete",
				message: "Are you sure you want to delete this content?",
				buttons: [
					{
						style: "destructive",
						text: "Delete",
						onPress: async () => {
							track(amp.photo.delete.confirm, {
								photoId,
							});
							await handleDeletePhotos([photoId]);
							toast({
								preset: "done",
								title: "Success",
								message: "Content deleted",
							});
							onDelete?.();
						},
					},
					{
						style: "cancel",
						text: "Cancel",
						onPress: () => {
							track(amp.photo.delete.cancel, {
								photoId,
							});
						},
					},
				],
			});
		},
		[handleDeletePhotos],
	);

	return {
		promptDeletePhoto: handleDeletePhoto,
	};
};
export default usePromptDeletePhoto;
